import React from 'react';
import { useLocale, getLanguageDisplayName } from '../context/LocaleContext';
import styles from '../styles/languageOffer.module.css';

// Always in English so English readers can find it, whatever language is showing.
const SWITCH_TO_ENGLISH = 'Switch to English';

/**
 * One-time banner when browser language matches a published non-English locale:
 * signed-out visitors were switched automatically and can switch back;
 * signed-in users are offered the language.
 */
const LanguageOfferBanner: React.FC = () => {
  const {
    offerLanguage,
    acceptOffer,
    declineOffer,
    autoLanguage,
    keepAutoLanguage,
    revertAutoLanguage,
    t,
  } = useLocale();

  if (autoLanguage) {
    const language = getLanguageDisplayName(autoLanguage);
    return (
      <div className={styles.banner} role="dialog" aria-label={t('i18n.offer.title')}>
        <div className={styles.inner}>
          <p className={styles.body}>{t('i18n.auto.body', { language })}</p>
          <div className={styles.actions}>
            <button type="button" className={styles.accept} onClick={keepAutoLanguage}>
              {t('i18n.auto.keep', { language })}
            </button>
            <button type="button" className={styles.decline} lang="en" onClick={revertAutoLanguage}>
              {SWITCH_TO_ENGLISH}
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!offerLanguage) return null;

  const language = getLanguageDisplayName(offerLanguage);

  return (
    <div className={styles.banner} role="dialog" aria-label={t('i18n.offer.title')}>
      <div className={styles.inner}>
        <p className={styles.body}>{t('i18n.offer.body', { language })}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.accept} onClick={() => void acceptOffer()}>
            {t('i18n.offer.accept', { language })}
          </button>
          <button type="button" className={styles.decline} onClick={declineOffer}>
            {t('i18n.offer.decline')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageOfferBanner;
